<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('settings.title') }}</h3>
        </div>

        <div class="list" v-if="(isLoaded)">
            <div>{{ $t('settings.header')}}</div>
            <ul>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 4000) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))"
                >
                    <template>
                        <template >
                            <router-link
                                :to="{ name: 'AubeCoinMembershipFeePolicy' }"
                                class="nav-link"
                                :class="{'disabled': isDisableForthingProcedureStatus}"
                            >
                                {{ $t('payment.messages.title') }}
                            </router-link>
                        </template>
                    </template>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 4000) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))">
                    <router-link v-if="(this.isLoaded)" class="nav-link" to="/kyc-settings" :class="{disabled: this.kycApproval}">
                        {{ $t('kyc.settings.title') }}
                    </router-link>
                </li>
                <li v-if="onlyShowAdvancedRenewal && !checkNotMemberShipFeeActive">
                    <router-link class="nav-link" to="/activation">
                        {{ $t('settings.force.activate') }}
                    </router-link>
                </li>
                <li v-if="onlyShowAdvancedRenewal && !checkNotMemberShipFeeActive">
                    <!-- HEC Saving申し込み -->
                    <router-link class="nav-link"
                                :class="{disabled: isFeeHecSavingApplication()}"
                                :to="{ name: 'hecSavingApplication' }">
                        {{ $t('hecSaving.messages.title') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 4000) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220) ||
                    (! isChild && isMembertype == 2100))">
                    <router-link class="nav-link" to="/account/edit-profile">
                        {{ $t('settings.account.info') }}
                    </router-link>
                </li>
                <li>
                    <router-link class="nav-link" to="/account/reset-password">
                        {{ $t('settings.account.resetPassword') }}
                    </router-link>
                </li>
                <li>
                    <router-link class="nav-link" to="/account/2sa">
                        {{ $t('settings.account.2sa') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 4000) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220) ||
                    (! isChild && isMembertype == 2100))">
                    <router-link class="nav-link" to="/account/change-mail-request">
                        {{ $t('settings.account.mail') }}
                    </router-link>
                </li>
                <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 4000) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)"
                >
                    <router-link class="nav-link" :to="{ name: 'historyOfForthingAgreement' }">
                        {{ $t('settings.forthingAgreement.history') }}
                    </router-link>
                </li>
                <li v-if="onlyShowAdvancedRenewal && this.latestMembershipFee && this.latestMembershipFee.is_active">
                    <router-link class="nav-link" to="/messages">
                        {{ $t('settings.account.status') }}
                    </router-link>
                </li>
                <li v-if="!isChild && isMembertype !== 2100 && checkNotMemberShipFeeActive">
                    <router-link class="nav-link" :to="{ name: 'aube-coin-forthing-status' }">
                        {{ $t('settings.account.status_aube_coin') }}
                    </router-link>
                </li>
                <li v-if="!isChild && isMembertype !== 2100 && checkNotMemberShipFeeActive">
                    <router-link
                        class="nav-link"
                        :class="{ disabled: !kycApproval || !is_aube_coin_staking_applied }"
                        :to="{ name: 'aubeCoinStakingApplication' }"
                    >
                        {{ $t('settings.account.staking2') }}
                    </router-link>
                </li>
            </ul>

            <div v-if="((! isChild && isMembertype == 1200) ||
                (! isChild && isMembertype == 4000) ||
                (! isChild && isMembertype == 1210) ||
                (! isChild && isMembertype == 1220) ||
                (! isChild && isMembertype == 2100))">
                <div>{{ $t('account.child.title') }}</div>
                <ul>
                    <li>
                        <router-link class="nav-link" to="/account/sub-account">
                            {{ $t('account.child.manage') }}
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- トークン(HEC) -->
            <div v-if="(! isChild)">
                <div>{{ $t('settings.token.title') }}</div>
                <ul>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'forthing-detail' }">{{ $t('settings.forthing.detail') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'exbonus-history' }">{{ $t('settings.exBonus.history') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 4000) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220) ||
                        (! isChild && isMembertype == 2100)">
                        <router-link class="nav-link" :to="{ name: 'token-detail' }">{{ $t('settings.token.detail') }}</router-link>
                    </li>
                    <li v-if="onlyShowAdvancedRenewal">
                        <router-link class="nav-link" to="/hec-saving/automatic-remittance"
                            :class="{disabled: this.is_hecsaving_applied}">
                            {{ $t('settings.hecsaving.title') }}
                        </router-link>
                    </li>
                    <li v-if="(!isChild && isMembertype == 1200) ||
                        (!isChild && isMembertype == 4000) ||
                        (!isChild && isMembertype == 1210) ||
                        (!isChild && isMembertype == 1220) ||
                        (!isChild && isMembertype == 2100)">
                        <router-link class="nav-link" :to="{ name: 'tokenCsv' }">{{
                            $t('settings.walletTransactionHistory.title') }}</router-link>
                    </li>
                </ul>
            </div>

            <!-- トークン(AUBE Coin) -->
            <!-- NOTE: If dev uncomment menu Wallet and Create a Wallet Transaction History
             => please remove isMembertype !== 2100 below -->
            <div v-if="(!isChild)">
                <div>{{ $t('settings.aubeCoin.title') }}</div>
                <ul>
                    <li v-if="(!isChild && isMembertype == 1200) ||
                        (!isChild && isMembertype == 4000) ||
                        (!isChild && isMembertype == 1210) ||
                        (!isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'aube-coin-forthing-detail' }">
                            {{ $t('settings.forthing.detail') }}
                        </router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'aube-coin-exbonus-history' }">
                            {{ $t('settings.aubeCoin.ex_bonus') }}
                        </router-link>
                    </li>
                    <!--<li v-if="(!isChild && isMembertype == 1200) ||
                        (!isChild && isMembertype == 4000) ||
                        (!isChild && isMembertype == 1210) ||
                        (!isChild && isMembertype == 1220) ||
                        (!isChild && isMembertype == 2100)">
                        <router-link class="nav-link" :to="{ name: 'home' }">
                            {{ $t('settings.aubeCoin.detail') }}
                        </router-link>
                    </li>-->
                    <li v-if="(!isChild && isMembertype !== 2100)">
                        <router-link
                            class="nav-link" to="/aube-coin-staking/automatic-remittance"
                            :class="{disabled: this.is_aube_coin_staking_applied}"
                        >
                            {{ $t('settings.aubeCoin.auto_staking') }}
                        </router-link>
                    </li>
                    <!-- FT-002 AUBE Stake: wallet (phase 1) -->
                    <li>
                        <router-link class="nav-link" :to="{ name: 'userWallet' }">
                            {{ $t('settings.public_wallet.detail') }}
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- トークン(Ethereum) -->
            <!--<div v-if="(!isChild)">
                <div>{{ $t('settings.eth.title') }}</div>
                <ul>
                    <li>
                        <router-link class="nav-link" :to="{ name: 'home' }">
                            {{ $t('settings.eth.wallet') }}
                        </router-link>
                    </li>
                    <li>
                        <router-link class="nav-link" :to="{ name: 'home' }">
                            {{ $t('settings.eth.create_wallet') }}
                        </router-link>
                    </li>
                </ul>
            </div>-->

            <!-- 外部サービス/External Service -->
            <div>
                <div>{{ $t('settings.hecstaking.title') }}</div>
                <ul>
                    <li>
                        <a v-bind:href="this.hec_staking_url" class="nav-link">{{ $t('settings.hecstaking.detail') }}</a>
                    </li>
                    <template>
                        <li>
                            <a v-bind:href="this.metax_pro_url" class="nav-link">{{ $t('settings.metaxPro.detail') }}</a>
                        </li>
                    </template>
                    <li>
                        <template>
                            <a v-bind:href="this.staking2" class="nav-link">{{ $t('settings.staking2.detail') }}</a>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../services/UserService";
    import { KYC_SETTINGS_APPROVAL } from '../utils/Const';
    import kycService from '../services/KycService';
    import userService from '../services/UserService';

    export default {
        name: 'settings',

        data() {
            return {
                isChild: true,
                isLoaded: false,
                latestMembershipFee: undefined,
                isMembertype: 0,
                kycStatus: undefined,
                kycApproval: '',
                hec_card_url: process.env.MIX_HEC_CARD_URL,
                hec_staking_url: process.env.MIX_HEC_STAKING_URL,
                metax_pro_url: process.env.MIX_METAX_PRO_URL,
                staking2: process.env.MIX_AUBE_COIN_STAKING_URL,
                notForceClubMember: false,
                is_hecsaving_applied: true,
                is_aube_coin_staking_applied: true,
                is_hecsaving_applied_disabled: true,
                membertypeDetail: undefined,
                precedenceEmailEnv: '',
                display: false,
                service: '',
                user_id: '',
                type: '',
                isConnector: false,
                isAdvancedRenewal: false,
                checkAvailabilityMember: false,
                latestAubeCoinMembershipFee: undefined
            }
        },

        computed: {
            checkNotMemberShipFeeActive() {
                if(!this.isAdvancedRenewal) {
                    return true;
                }
                //check B' expire membership fee
                return !this.latestMembershipFee || !this.latestMembershipFee.is_active;
            },

            onlyShowAdvancedRenewal() {
                return !this.isChild
                    && (this.isMembertype === 1200 || this.isMembertype === 1210 || this.isMembertype === 1220)
                    && this.isAdvancedRenewal
            },
            isDisableForthingProcedureStatus() {
                if (!this.checkAvailabilityMember || !this.kycApproval || this.is_aube_coin_staking_applied) {
                    return true;
                }

                const hasActiveAubeMembershipFee =
                    this.latestAubeCoinMembershipFee &&
                    this.latestAubeCoinMembershipFee.is_active;

                // check membershipfee is active for  user Patter B (advance )
                const hasActiveMembershipFee =
                    this.latestMembershipFee &&
                    this.latestMembershipFee.is_active;


                return hasActiveAubeMembershipFee || hasActiveMembershipFee
            }
        },

        async updated(){

            if(Number(this.kycService) == KYC_SETTINGS_APPROVAL){
                this.kycApproval = true
            }else{
                this.kycApproval = false
            }

        },

        created() {
            this.sessionOrderClear();
            this.fetchUserFrontendData()
            this.checkValidQuest()
        },

        methods: {
            async submit() {
                const data = (await UserService.getUserFrontendData()).data;
                this.service = "aube";
                this.user_id = data.external_user_id;
                this.type = (await UserService.getType(data.email)).data.vip_rank;
                this.$nextTick(function() {
                    document.atemCard.submit();
                });

            },
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isMembertype = data.member_type_id
                this.isChild = data.is_child

                if(process.env.MIX_PRECEDENCE_EMAIL != undefined){
                    this.precedenceEmailEnv = process.env.MIX_PRECEDENCE_EMAIL.split(',')
                    if (this.precedenceEmailEnv.includes(data.email)) {
                        if((! this.isChild && this.isMembertype == 2100) || (! this.isChild && this.isMembertype == 2200)){
                            this.type = (await UserService.getType(data.email)).data.vip_rank
                            if(this.type >= 2){
                                this.display = true
                            }
                        }else{
                            this.display = true
                        }
                    }
                }else{
                    if((! this.isChild && this.isMembertype == 2100) || (! this.isChild && this.isMembertype == 2200)){
                        this.type = (await UserService.getType(data.email)).data.vip_rank
                        if(this.type >= 2){
                            this.display = true
                        }
                    }else{
                        this.display = true
                    }
                }

                const forceClubData = await UserService.getForceClubInfoData(); //ForceClub退会、停止情報取得

                if (data.is_hecsaving_applied) {
                    // is_hecsaving_appliedがtrueの場合はリンク活性化
                    this.is_hecsaving_applied = false;
                } else {
                    // is_hecsaving_appliedがfalseの場合はリンク非活性化
                    this.is_hecsaving_applied = true;
                }

                if (data.is_aube_coin_staking_applied) {
                    // is_hecsaving_appliedがtrueの場合はリンク活性化
                    this.is_aube_coin_staking_applied = false;
                } else {
                    // is_hecsaving_appliedがfalseの場合はリンク非活性化
                    this.is_aube_coin_staking_applied = true;
                }

                try{
                    const result = (await kycService.getStatus()).data
                    this.kycService = result.status
                }catch{
                    this.kycApproval = true
                }

                this.is_hecsaving_applied_disabled = data.is_hecsaving_applied

                this.latestMembershipFee = data.latestMembershipFee;

                this.isLoaded = true;

                this.isMembertype = data.member_type_id;

                this.notForceClubMember = forceClubData.data;

                this.membertypeDetail = data.membertypeDetail; //メンバータイプ詳細（プレミアム、サポート、アップグレードメンバー）
                this.isConnector = data.connector ? true : false;

                this.isAdvancedRenewal = data.is_advanced_renewal;

                this.latestAubeCoinMembershipFee = data.latestAubeCoinMembershipFee || null;
            },
            isMembershipFeePayable() {
                // ITSOL_FORTHING_GEN2-69 20-3 フォルシング開始手続き: -> 09/09/2025: Set disabled to true
                return true;

                // ForceClubを退会、停止している場合
                if(this.notForceClubMember){
                    return true;
                }
                // HEC Saving申込していない場合
                // フォルシング契約の状態：未完了、完了、次回契約受付中のいずれかの場合
                if(!this.is_hecsaving_applied_disabled){
                    return true;
                }
                // HEC Saving申込している場合
                // フォルシング契約の状態：完了の場合
                else if (this.latestMembershipFee && this.latestMembershipFee.is_active) {
                    return true;
                }
                // HEC Saving申込している場合
                // フォルシング契約の状態：未完了、または次回契約受付中の場合
                return false;
            },
            isDisabledLink() {
                return true;
            },
            sessionOrderClear() {
                sessionStorage.removeItem('formData');
            },
            //HEC Saving申込 状態：完了
            isFeeHecSavingApplication() {
                if(this.is_hecsaving_applied_disabled){
                    return true;
                }
            },

            async checkValidQuest() {
                const availabilityCheckData = await userService.questAvailabilityCheckData();
                this.checkAvailabilityMember = !!availabilityCheckData.data;
            },
        }
    }
</script>

<style>

</style>
